const gridView = document.querySelectorAll('.grid-view span')
if(gridView) {    
  gridView.forEach(el => {          
    el.addEventListener('click', () => {        
      gridView.forEach(el => el.classList.remove('active'))
      el.classList.add('active')                
      document.querySelector('#product-grid').dataset.view = el.dataset.gridView
    })      
  })
  
  setTimeout(() => {
    if(window.innerWidth < 1024) {
      document.querySelector('.grid-view span[data-grid-view="1"]').classList.remove('active')
      document.querySelector('.grid-view span[data-grid-view="2"]').classList.add('active')                        
    }
  }, 250)    
}